// Formes à détruire (dossier §4). Cinq raretés distinctes par silhouette, texture et lueur.

export interface ShapeDef {
  kind: number;
  id: 'F1' | 'F2' | 'F3' | 'F4' | 'F5';
  name: string;
  sides: number;
  radius: number;
  hp: number;
  xp: number;
  /** Dégâts infligés au contact (par intervalle de contact). */
  bodyDamage: number;
  /** Ce que retire la forme à la pénétration d'un projectile qui la touche. */
  armor: number;
}

export const SHAPES: ShapeDef[] = [
  { kind: 0, id: 'F1', name: 'Plaque', sides: 4, radius: 20, hp: 30, xp: 10, bodyDamage: 4, armor: 6 },
  { kind: 1, id: 'F2', name: 'Éclat', sides: 3, radius: 24, hp: 70, xp: 30, bodyDamage: 6, armor: 8 },
  { kind: 2, id: 'F3', name: 'Rouage', sides: 5, radius: 34, hp: 180, xp: 90, bodyDamage: 8, armor: 10 },
  { kind: 3, id: 'F4', name: 'Cristal', sides: 6, radius: 44, hp: 550, xp: 300, bodyDamage: 12, armor: 14 },
  { kind: 4, id: 'F5', name: 'Noyau', sides: 8, radius: 62, hp: 1800, xp: 1200, bodyDamage: 18, armor: 20 },
];

/** Zones de danger : 0 gris, 1 vert, 2 orange, 3 rouge, 4 violet. */
export type ZoneLevel = 0 | 1 | 2 | 3 | 4;

/** Probabilités de génération par zone (en %), ordre F1..F5. */
export const SHAPE_WEIGHTS: Record<ZoneLevel, number[]> = {
  0: [70, 22, 7, 0.9, 0.1],
  1: [60, 27, 10, 2.7, 0.3],
  2: [49, 30, 15, 5, 1],
  3: [35, 32, 22, 9, 2],
  4: [35, 30, 23, 10, 2],
};

/** Densité cible de formes par million d'unités² selon la zone (pool strictement borné). */
export const SHAPE_DENSITY: Record<ZoneLevel, number> = { 0: 10, 1: 9, 2: 8, 3: 7, 4: 5 };
/** Délai avant qu'une forme détruite ne soit remplacée (s). */
export const SHAPE_RESPAWN_S = 6;
